import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { SperrigkeitService } from '../../api';

export const getSperrigkeiten =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new SperrigkeitService().getSperrigkeiten(mandantId).then(result => {
      dispatch({
        type: ActionTypes.GET_SPERRIGKEITEN,
        payload: result.data,
      });
    });
  };
